const mercadoPagoInitialState = {
  mercadoPago: {
    loading: false,
    error: null,
    data: null,
  },
  referencia: {
    loading: false,
    error: null,
    data: null,
  },
};

export default mercadoPagoInitialState;
